import { EnvironmentTypes, gameConfigStore } from '@pascal/pascal-core';
import { oddballBetShopGameId, oddballBogGameId } from './gameConfigsAndUrls';

const getCurrentGameApplicationId = () => {
  const { gameId } = gameConfigStore;
  const gameStageApplicationIds = {
    [oddballBogGameId]: 42,
    [oddballBetShopGameId]: 39,
  };

  const gameProdApplicationIds = {
    [oddballBogGameId]: 36,
    [oddballBetShopGameId]: 33,
  };

  return process.env.REACT_APP_ENV === EnvironmentTypes.Production
    ? gameProdApplicationIds[gameId]
    : gameStageApplicationIds[gameId];
};

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: getCurrentGameApplicationId(),
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
